export const SHAPE_COLORS = [
    '#4A90D9', '#E74C3C', '#2ECC71', '#F39C12', '#9B59B6',
    '#1ABC9C', '#E67E22', '#3498DB', '#ffffff', '#95A5A6',
]

export const SHAPE_TYPES = [
    { value: 'RECTANGLE', label: '□' },
    { value: 'ROUNDED_RECTANGLE', label: '▢' },
    { value: 'OVAL', label: '○' },
    { value: 'TRIANGLE', label: '△' },
    { value: 'DIAMOND', label: '◇' },
    { value: 'DATABASE', label: '⛁' },
    { value: 'QUEUE', label: '⬭' },
    { value: 'PROCESS', label: '⬡' },
]
